export enum CategoryEnum {
  SKILL = "SKILL",
  LANGUAGE = "LANGUAGE",
  COUNTRY = "COUNTRY",
  SPECIALIZATION = "SPECIALIZATION",
  CAREER_LEVEL = "CAREER_LEVEL",
  QUALIFICATION = "QUALIFICATION",
  INDUSTRY = "INDUSTRY",
  EMPLOYMENT_TYPE = "EMPLOYMENT_TYPE",
  CONTRACT_TYPE = "CONTRACT_TYPE",
  COMPANY_SIZE = "COMPANY_SIZE",
  INTERVIEWER_AVATAR = "INTERVIEWER_AVATAR",
  INTERVIEWER_VOICE = "INTERVIEWER_VOICE"
}

export enum LookupStatus {
  IDLE,
  LOADING,
  SUCCESS,
  FAIL
}